module.exports = __webpack_public_path__ + "img/IMG_0459.e70b9fcc.jpg";